import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeRemoveKeyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22.38 11.58L12.42 1.61999C12.19 1.38999 11.81 1.38999 11.57 1.61999L1.62001 11.58C1.39001 11.81 1.39001 12.19 1.62001 12.43L11.57 22.38C11.8 22.61 12.18 22.61 12.42 22.38L22.37 12.43C22.6 12.2 22.6 11.82 22.37 11.58H22.38ZM16.8 13H7.20001C6.65001 13 6.20001 12.55 6.20001 12C6.20001 11.45 6.65001 11 7.20001 11H16.8C17.35 11 17.8 11.45 17.8 12C17.8 12.55 17.35 13 16.8 13Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeRemoveKeyIcon.displayName = 'TimeRemoveKeyIcon';
